import React from 'react';
import headerStyles from '../PortfolioHeader/PortfolioHeader.module.scss';
import styles from './PortfolioSkeleton.module.scss';

/** Placeholder header shown while the portfolio user loads. */
const PortfolioSkeleton = () => (
  <div className={headerStyles.portfolioHeader} aria-busy="true">
    <span className="sr-only">Loading portfolio</span>
    <div className={headerStyles.cover} />
    <div className={headerStyles.container}>
      <div className={headerStyles.card} aria-hidden="true">
        <div className={headerStyles.avatar}>
          <span className={`${headerStyles.avatarImage} ${styles.block}`} />
        </div>
        <div className={headerStyles.main}>
          <span className={styles.block} style={{ width: 240, height: 28 }} />
          <span className={styles.block} style={{ width: 320, height: 26 }} />
          <span className={styles.block} style={{ width: 280, height: 16 }} />
          <span
            className={styles.block}
            style={{ width: '100%', maxWidth: 560, height: 40 }}
          />
        </div>
      </div>
    </div>
  </div>
);

export default PortfolioSkeleton;
